import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import activities from "../activities/redux/activitiesReducer";
import staffSales from "../sales/redux/salesReducer";
import { all } from "redux-saga/effects";
import watchActivities from "../activities/redux/activitiesSaga";
import watchStaffSales from "../sales/redux/salesSaga";
import { handleActions, createAction } from "redux-actions";

//commonReducer
const initialState = {
  currentUser: {}
};

export const fetchCurrentUser = createAction("staffActivity/FETCH_CURRENT_USER");

const commonReducer = handleActions(
  {
    ["staffActivity/FETCH_CURRENT_USER"]: (state, action) => {
      return {
        ...state,
        currentUser: action.payload
      };
    }
  },
  initialState
);

const allSagas = {
  activities: watchActivities(),
  staffSales: watchStaffSales()
};

const allReducers = {
  activities,
  staffSales
};

function getReducersAndWatchers(modules) {
  let reducers = {};
  let sagas = [];

  for (let moduleName of modules) {
    reducers = { ...reducers, [moduleName]: allReducers[moduleName] };
    sagas = [...sagas, allSagas[moduleName]];
  }

  return { reducers, sagas };
}

const sagaMiddleware = createSagaMiddleware();

export function createReduxStore(name, modules) {
  const composeEnhancers = composeWithDevTools({ name });
  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware));

  const { reducers: currentReducers, sagas } = getReducersAndWatchers(modules);

  const reducers = combineReducers({
    commonReducer,
    ...currentReducers
  });

  let store = createStore(reducers, middleware);

  sagaMiddleware.run(function* rootSaga() {
    yield all(sagas);
  });

  
  return store;
}
